export const labelStyled = {
  fontSize: "1rem",
  lineHeight: "24.5px",
  color: "primary.main",
  textTransform: "capitalize",
};
export const groupStyled = {
  gap: "1rem",
  width: "100%",
};
export const columnCentered = {
  ...groupStyled,
  display: "flex",
  flexDirection: "column",
  gap: "2em",

  //alignItems: "center",
  //justifyContent: "center",
};
export const column = {
  display: "flex",
  flexDirection: "column",
  gap: "1.8rem",
  width: "100%",
};
export const row = {
  display: "flex",
  gap: "1.8rem",
  width: "100%",
};
export const col = {
  display: "flex",
  flexDirection: "column",
  gap: "1.8rem",
  width: "50%",
};
export const formGroupContainer = {
  display: "flex",
  gap: "1.8rem",
  width: "100%",
};
export const header = {
  //border: "1px solid black",
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};
export const leftCol = {
  display: "flex",
  flexDirection: "column",
  width: "50%",
  gap: "1.8rem",
};
